/* eslint-disable camelcase */
export default class Voucher {
  created_at = '';
  created_by = '';
  created_by_user = '';
  updated_by_user = '';
  voucher_items = [];
  id = 0;
  memo = '';
  voucher_date = '';
  partner = {};
  updated_by = '';
  payment_term_id = 0;
  due_date = '';
  paid_amount = 0;
  balance = 0;
  is_blank = 0;
  order_no = '';
  purchase_order_id = '';
  partner_id = '';
  sales_rep_id = '';
  delivery_slip_id = '';
  vendor_invoice_no = '';
  partner_name = '';
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Voucher.js